import { BdcInvoiceSummary } from "../../../types/bdc.type";
import Tag from "../Tag";

/** ออกแล้ว / ยกเลิก, plus ทดสอบ for a TB… INV. */
export default function InvoiceStatusChip({ invoice }: Readonly<{ invoice: Pick<BdcInvoiceSummary, "status" | "is_test"> }>) {
  return (
    <>
      {invoice.status === "cancelled" ? <Tag tone="crit">ยกเลิก</Tag> : <Tag tone="ok">ออกแล้ว</Tag>}
      {invoice.is_test && (
        <>
          {" "}
          <Tag tone="warn">ทดสอบ</Tag>
        </>
      )}
    </>
  );
}
